import { useState } from 'react';

interface Highlight {
  id: string;
  label: string;
  icon: string;
  modalTitle: string;
  modalImage: string;
  modalText: string;
}

const highlights: Highlight[] = [
  {
    id: 'quem-sou',
    label: 'Quem sou',
    icon: 'ri-user-star-line',
    modalTitle: 'Quem sou',
    modalImage: 'https://readdy.ai/api/search-image?query=Luxury%20medical%20office%20interior%2C%20minimalist%20dark%20walls%20with%20warm%20ambient%20lighting%2C%20elegant%20cream%20leather%20chairs%2C%20golden%20accent%20details%2C%20fresh%20white%20orchids%20on%20desk%2C%20editorial%20interior%20photography%2C%20moody%20warm%20atmosphere%2C%20high-end%20wellness%20clinic&width=600&height=400&seq=highlight-quem-sou-dark&orientation=landscape',
    modalText: 'Dra. Melissa Ciríaco é médica com CRM-CE 21438, especializada em emagrecimento saudável, tratamento de lipedema, reposição hormonal e saúde metabólica. Sua abordagem combina ciência baseada em evidências com um olhar humano e individualizado para cada paciente.',
  },
  {
    id: 'resultados',
    label: 'Resultados',
    icon: 'ri-line-chart-line',
    modalTitle: 'Resultados',
    modalImage: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20looking%20confidently%20in%20mirror%2C%20dramatic%20side%20lighting%2C%20dark%20moody%20background%20with%20warm%20golden%20tones%2C%20wellness%20transformation%20portrait%2C%20editorial%20fashion%20photography%20style%2C%20luxury%20aesthetic%2C%20shallow%20depth%20of%20field&width=600&height=400&seq=highlight-resultados-dark&orientation=landscape',
    modalText: 'Centenas de pacientes já transformaram sua saúde e autoestima através de um acompanhamento médico personalizado. Cada resultado é único, assim como cada história.',
  },
  {
    id: 'emagrecimento',
    label: 'Emagrecimento',
    icon: 'ri-scales-line',
    modalTitle: 'Emagrecimento Saudável',
    modalImage: 'https://readdy.ai/api/search-image?query=Healthy%20fresh%20food%20arrangement%20on%20dark%20marble%20surface%2C%20minimal%20composition%20with%20warm%20golden%20ambient%20light%2C%20dark%20moody%20wellness%20photography%2C%20herbs%20and%20greens%20with%20golden%20accent%20lighting%2C%20luxury%20food%20editorial&width=600&height=400&seq=highlight-emagrecimento-dark&orientation=landscape',
    modalText: 'Cada organismo possui necessidades únicas. O tratamento é individualizado para promover perda de peso com segurança, saúde e acompanhamento médico contínuo.',
  },
  {
    id: 'hormonios',
    label: 'Hormônios',
    icon: 'ri-mental-health-line',
    modalTitle: 'Reposição Hormonal',
    modalImage: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20her%2040s%20with%20vibrant%20healthy%20glow%2C%20dark%20moody%20background%2C%20warm%20golden%20rim%20light%2C%20wellness%20lifestyle%20portrait%2C%20editorial%20photography%2C%20luxury%20aesthetic%20with%20dark%20tones%2C%20confident%20expression&width=600&height=400&seq=highlight-hormonios-dark&orientation=landscape',
    modalText: 'Investigação clínica e laboratorial completa para restaurar o equilíbrio hormonal de forma personalizada, respeitando as necessidades de cada paciente.',
  },
  {
    id: 'lipedema',
    label: 'Lipedema',
    icon: 'ri-heart-pulse-line',
    modalTitle: 'Lipedema',
    modalImage: 'https://readdy.ai/api/search-image?query=Woman%20walking%20gracefully%20in%20nature%20at%20golden%20hour%2C%20feeling%20free%20and%20light%2C%20dark%20moody%20landscape%20with%20warm%20sunlight%20breaking%20through%2C%20editorial%20wellness%20photography%2C%20peaceful%20atmosphere%20with%20dark%20greens%20and%20golden%20tones&width=600&height=400&seq=highlight-lipedema-dark&orientation=landscape',
    modalText: 'Avaliação completa para identificar sinais de lipedema e elaborar estratégias personalizadas para aliviar sintomas e melhorar a qualidade de vida.',
  },
  {
    id: 'consulta',
    label: 'Consulta',
    icon: 'ri-calendar-check-line',
    modalTitle: 'Como funciona a consulta',
    modalImage: 'https://readdy.ai/api/search-image?query=Luxury%20doctor%20consultation%20room%2C%20dark%20moody%20interior%20with%20warm%20golden%20ambient%20lighting%2C%20comfortable%20cream%20leather%20chairs%2C%20minimalist%20elegant%20design%2C%20dark%20wood%20accents%2C%20fresh%20flowers%2C%20editorial%20interior%20photography&width=600&height=400&seq=highlight-consulta-dark&orientation=landscape',
    modalText: 'Avaliação completa, investigação das causas, exames individualizados, plano de tratamento personalizado e acompanhamento contínuo. Tudo em um ambiente acolhedor.',
  },
  {
    id: 'clinica',
    label: 'Infinity Clínica',
    icon: 'ri-building-line',
    modalTitle: 'Infinity Clínica Avançada',
    modalImage: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20medical%20clinic%20exterior%20at%20dusk%2C%20minimalist%20architecture%20with%20warm%20interior%20lighting%20glowing%20through%20windows%2C%20dark%20facade%20with%20golden%20accent%20lights%2C%20elegant%20design%2C%20editorial%20architecture%20photography%2C%20moody%20twilight%20atmosphere&width=600&height=400&seq=highlight-clinica-dark&orientation=landscape',
    modalText: 'A Infinity Clínica Avançada oferece estrutura completa para seu atendimento, combinando tecnologia, conforto e um ambiente pensado para seu bem-estar.',
  },
  {
    id: 'faq',
    label: 'Dúvidas',
    icon: 'ri-question-line',
    modalTitle: 'Dúvidas Frequentes',
    modalImage: 'https://readdy.ai/api/search-image?query=Calm%20reading%20corner%20with%20warm%20golden%20lamp%20light%2C%20dark%20moody%20atmosphere%2C%20cream%20and%20dark%20brown%20tones%2C%20minimalist%20design%20with%20soft%20textures%2C%20wellness%20lifestyle%20photography%2C%20peaceful%20and%20intimate%20setting&width=600&height=400&seq=highlight-faq-dark&orientation=landscape',
    modalText: 'Tire suas dúvidas sobre os tratamentos, consultas e como dar o primeiro passo para transformar sua saúde e qualidade de vida.',
  },
];

export default function HighlightsCarousel() {
  const [selectedHighlight, setSelectedHighlight] = useState<Highlight | null>(null);
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <>
      <section id="destaques" className="relative py-16 md:py-20 overflow-hidden" style={{ backgroundColor: '#0E1412' }}>
        {/* Subtle grain */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
            backgroundRepeat: 'repeat',
            backgroundSize: '256px 256px',
            opacity: 0.025,
          }}
        />

        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="flex items-center gap-8 md:gap-12 overflow-x-auto pb-4 scrollbar-hide justify-center flex-nowrap animate-marquee-container">
            <div className="flex items-center gap-8 md:gap-12 animate-marquee">
              {[...highlights, ...highlights].map((item, idx) => (
                <button
                  key={`${item.id}-${idx}`}
                  onClick={() => setSelectedHighlight(item)}
                  onMouseEnter={() => setHoveredId(item.id)}
                  onMouseLeave={() => setHoveredId(null)}
                  className="flex-shrink-0 flex flex-col items-center gap-3 group cursor-pointer min-w-[100px]"
                >
                  <div
                    className="relative w-[72px] h-[72px] md:w-[88px] md:h-[88px] rounded-full flex items-center justify-center transition-all duration-500"
                    style={{
                      transform: hoveredId === item.id ? 'scale(1.08)' : 'scale(1)',
                    }}
                  >
                    <div
                      className="absolute inset-0 rounded-full transition-all duration-500"
                      style={{
                        border: hoveredId === item.id
                          ? '1.5px solid rgba(200, 169, 106, 0.5)'
                          : '1.5px solid rgba(248, 247, 245, 0.08)',
                      }}
                    />
                    <div
                      className="absolute inset-[4px] rounded-full transition-all duration-500"
                      style={{
                        border: '1px solid rgba(248, 247, 245, 0.04)',
                      }}
                    />
                    <div
                      className="absolute inset-[-8px] rounded-full transition-opacity duration-500"
                      style={{
                        opacity: hoveredId === item.id ? 1 : 0,
                        background: 'radial-gradient(circle, rgba(200, 169, 106, 0.08) 0%, transparent 70%)',
                      }}
                    />
                    <i
                      className={`${item.icon} text-xl md:text-2xl relative z-10 transition-all duration-500`}
                      style={{
                        color: hoveredId === item.id ? '#C8A96A' : 'rgba(248, 247, 245, 0.3)',
                      }}
                    />
                  </div>
                  <span
                    className="text-[10px] md:text-xs tracking-[0.06em] whitespace-nowrap transition-all duration-300"
                    style={{
                      fontFamily: 'var(--font-body)',
                      color: hoveredId === item.id ? '#C8A96A' : 'rgba(248, 247, 245, 0.35)',
                      fontWeight: hoveredId === item.id ? 500 : 400,
                    }}
                  >
                    {item.label}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedHighlight && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8"
          onClick={() => setSelectedHighlight(null)}
        >
          <div
            className="absolute inset-0"
            style={{
              backgroundColor: 'rgba(14, 20, 18, 0.85)',
              backdropFilter: 'blur(12px)',
              transition: 'all 0.5s ease',
            }}
          />
          <div
            className="relative z-10 overflow-hidden max-w-[560px] w-full animate-fade-up"
            style={{
              backgroundColor: '#151C19',
              borderRadius: '28px',
              border: '1px solid rgba(200, 169, 106, 0.1)',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedHighlight(null)}
              className="absolute top-4 right-4 z-20 w-8 h-8 flex items-center justify-center rounded-full cursor-pointer transition-all"
              style={{
                backgroundColor: 'rgba(14, 20, 18, 0.8)',
                border: '1px solid rgba(248, 247, 245, 0.1)',
              }}
            >
              <i className="ri-close-line text-lg" style={{ color: 'rgba(248, 247, 245, 0.6)' }} />
            </button>
            <div className="aspect-[3/2] overflow-hidden">
              <img
                src={selectedHighlight.modalImage}
                alt={selectedHighlight.modalTitle}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 md:p-8">
              <h3
                className="text-2xl md:text-3xl mb-4"
                style={{
                  fontFamily: 'var(--font-heading)',
                  color: '#F8F7F5',
                  fontWeight: 500,
                }}
              >
                {selectedHighlight.modalTitle}
              </h3>
              <p
                className="text-sm md:text-base leading-relaxed mb-6"
                style={{
                  fontFamily: 'var(--font-body)',
                  color: 'rgba(248, 247, 245, 0.5)',
                  fontWeight: 300,
                  lineHeight: 1.8,
                }}
              >
                {selectedHighlight.modalText}
              </p>
              <a
                href="https://wa.me/5585999372109?utm_source=site&utm_medium=highlights_modal&utm_content=agendar_consulta"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setSelectedHighlight(null)}
                className="inline-flex items-center px-6 py-2.5 rounded-full text-sm font-medium tracking-[0.03em] whitespace-nowrap cursor-pointer"
                style={{
                  backgroundColor: 'rgba(200, 169, 106, 0.15)',
                  color: '#C8A96A',
                  fontFamily: 'var(--font-body)',
                  border: '1px solid rgba(200, 169, 106, 0.25)',
                }}
              >
                Agendar consulta
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}